---
title: jottt
description: A design exercise to see how quickly I could write something down.
---

A design exercise to see how quickly I could write something down.

Coming soon.
